import { IWebsiteContact } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

interface IWebsiteBuilderItemContactSocial {
    linkedIn: string;
    linkedInEnabled: boolean;
    facebook: string;
    facebookEnabled: boolean;
    twitter: string;
    twitterEnabled: boolean;
}

export class WebsiteBuilderItemContact extends WebsiteBuilderItemBase {
    name = 'Contact';
    navName = 'Contact';
    navLink = 'contact';
    isShowInMenu = true;
    isHomePagePart = true;

    companyName: string = '';
    formEmail: string = '';
    formEmailEnabled: boolean = false;
    addressEnabled: boolean = false;
    address: string = '';
    emailEnabled: boolean = false;
    email: string = '';
    phoneEnabled: boolean = false;
    phone: string = '';
    faxEnabled: boolean = false;
    fax: string = '';
    officeHoursEnabled: boolean = false;
    officeHours: string[] = [];
    socialEnabled: boolean = false;
    social: IWebsiteBuilderItemContactSocial = {
        linkedIn: '',
        linkedInEnabled: false,
        facebook: '',
        facebookEnabled: false,
        twitter: '',
        twitterEnabled: false
    };

    set value(item: IWebsiteContact) {
        this.isPresent = item.status;
        this.formEmailEnabled = item.formEmailStatus;
        this.formEmail = item.formEmail;
        this.companyName = item.companyName;
        this.addressEnabled = item.addressStatus;
        this.address = item.address;
        this.emailEnabled = item.emailStatus;
        this.email = item.email;
        this.officeHoursEnabled = item.hoursStatus;
        this.officeHours = item.hours ? item.hours : [''];
        this.priority = item.priority;

        item.phones.forEach(phone => {
            if (phone.phoneType == 'phone' && phone.status) {
                this.phone = phone.phone;
                this.phoneEnabled = phone.status;
            } else if (phone.phoneType == 'fax' && phone.status) {
                this.fax = phone.phone;
                this.faxEnabled = phone.status;
            }
        });

        item.socialNetworks.forEach(social => {
            if (social.networkType == 'instagram') {
                this.social.linkedIn = social.socialUrl;
                this.social.linkedInEnabled = !!social.status;
            } else if (social.networkType == 'facebook') {
                this.social.facebook = social.socialUrl;
                this.social.facebookEnabled = !!social.status;
            } else if (social.networkType == 'twitter') {
                this.social.twitter = social.socialUrl;
                this.social.twitterEnabled = !!social.status;
            }
        });
    }

    get value(): IWebsiteContact {
        return {
            companyName: this.companyName,
            formEmail: this.formEmail,
            formEmailStatus: this.formEmailEnabled,
            addressStatus: this.addressEnabled,
            address: this.address,
            emailStatus: this.emailEnabled,
            email: this.email,
            hoursStatus: this.officeHoursEnabled,
            hours: this.officeHours,
            phones: [{
                phoneType: 'fax',
                phone: this.fax,
                status: this.faxEnabled
            }, {
                phoneType: 'phone',
                phone: this.phone,
                status: this.phoneEnabled
            }],
            socialNetworks: [
                {
                    networkType: 'instagram',
                    socialUrl: this.social.linkedIn,
                    status: this.social.linkedInEnabled
                }, {
                    networkType: 'facebook',
                    socialUrl: this.social.facebook,
                    status: this.social.facebookEnabled
                }, {
                    networkType: 'twitter',
                    socialUrl: this.social.twitter,
                    status: this.social.twitterEnabled
                }
            ],
            status: this.isPresent,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-contact.ts